/**
 * Згадки «@Ім'я» в коментарях (прототип v4: коментарі сповіщають згаданих): пошук незавершеної згадки біля курсора, вставка імені,
 * ідентифікатори згаданих для API (ICommentWrite.mentions) і поділ тексту на частини для підсвічування. Чисті функції.
 */

/** Незавершена згадка перед курсором: «@» на початку тексту або після пробілу, далі — літери без пробілів і символів кінця рядка. */
export function mentionAt(text: string, caret: number): { start: number; query: string } | null {
  const before = text.slice(0, caret);
  const m = /(^|\s)@([^\s@]{0,40})$/u.exec(before);
  return m ? { start: before.length - m[2]!.length - 1, query: m[2]! } : null;
}

/** Вставляє «@Ім'я » замість незавершеної згадки; повертає новий текст і позицію курсора після вставки. */
export function insertMention(text: string, start: number, caret: number, name: string): { text: string; caret: number } {
  const piece = `@${name} `;
  return { text: text.slice(0, start) + piece + text.slice(caret).replace(/^\s+/, ''), caret: start + piece.length };
}

/** Ідентифікатори людей, чиї «@Ім'я» лишилися в тексті (без повторів, у порядку першої появи). */
export function mentionIds(text: string, people: ReadonlyArray<{ id: string; name: string }>): string[] {
  return people.filter((p, i) => people.findIndex((x) => x.id === p.id) === i && text.includes(`@${p.name}`)).map((p) => p.id);
}

/** Частини тексту коментаря: звичайний текст і згадки відомих людей («@Ім'я») — для підсвічування; довші імена мають перевагу. */
export function splitMentions(text: string, names: readonly string[]): Array<{ text: string; mention: boolean }> {
  const sorted = [...new Set(names)].filter(Boolean).sort((a, b) => b.length - a.length);
  const parts: Array<{ text: string; mention: boolean }> = [];
  let rest = text;
  while (rest) {
    let at = -1; let hit = '';
    for (const n of sorted) {
      const i = rest.indexOf(`@${n}`);
      if (i >= 0 && (at < 0 || i < at)) { at = i; hit = `@${n}`; }
    }
    if (at < 0) { parts.push({ text: rest, mention: false }); break; }
    if (at > 0) parts.push({ text: rest.slice(0, at), mention: false });
    parts.push({ text: hit, mention: true });
    rest = rest.slice(at + hit.length);
  }
  return parts;
}
